import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Flame, ArrowRight } from "lucide-react";
import { API } from "../context/AppContext";

// Social proof strip fed by real paid orders (hidden until there is at least one sale in the window).
export default function BestSellers() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/products/best-sellers`).then(r => setData(r.data)).catch(() => setData(null));
  }, []);

  if (!data || data.items.length === 0) return null;

  return (
    <section className="relative border-t border-white/5 overflow-hidden" data-testid="best-sellers">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
          <div className="flex items-center gap-3">
            <Flame size={14} className="text-[color:var(--bl-gold)]" />
            <div className="bl-eyebrow text-[color:var(--bl-gold)]">
              Most shipped · {data.window_days === 7 ? "this week" : "last 30 days"}
            </div>
          </div>
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/40">From real orders · updates live</div>
        </div>
        <div className="flex gap-3 overflow-x-auto no-scrollbar snap-x pb-1">
          {data.items.map((p, i) => (
            <Link key={p.id} to={`/product/${p.slug}`} data-testid={`best-seller-${p.slug}`}
              className="group snap-start shrink-0 w-[240px] border border-white/8 bg-white/[0.015] hover:border-[color:var(--bl-blue)]/60 transition-colors p-4 flex items-center gap-4">
              <div className="relative w-14 h-14 shrink-0 bl-vial-placeholder overflow-hidden">
                {p.image && <img src={p.image} alt="" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />}
                <span className="absolute -top-1 -left-1 font-mono text-[9px] tracking-[0.2em] text-[color:var(--bl-gold)] bg-[color:var(--bl-black)] px-1.5 py-0.5 border border-[color:var(--bl-gold)]/40">#{i + 1}</span>
              </div>
              <div className="min-w-0">
                <div className="text-white text-sm truncate group-hover:text-[color:var(--bl-blue)] transition-colors">{p.name}</div>
                <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/40 mt-1 truncate">{p.category}</div>
                <div className="font-mono text-[10px] tracking-[0.15em] text-white/60 mt-1">
                  {p.units} pack{p.units === 1 ? "" : "s"} shipped · from A${p.from_price.toFixed(0)}
                </div>
              </div>
              <ArrowRight size={12} className="ml-auto text-white/30 group-hover:text-[color:var(--bl-blue)] shrink-0" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
